module.exports = __webpack_public_path__ + "img/電気回路_6_3_1.52cb26b5.png";